import SlideInWrapper from 'components/SlideInWrapper'
import HelpDeskIntegration from 'components/integrations/helpdesk/HelpDeskIntegration'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'

function HelpDesk() {
	useSectionOpenedTracking()

	return (
		<SlideInWrapper>
			<HelpDeskIntegration />
		</SlideInWrapper>
	)
}

export default HelpDesk
